import React from "react";
import "./RainbowBorder.css";

const RainbowBorder = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default RainbowBorder;
